// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.87.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.87.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.viewer-frame[data-v-bdedd782] {\n  width: 100%;\n  height: 100%;\n  border: 0 none;\n}\n.viewer-text[data-v-bdedd782] {\n  width: 100%;\n  height: 100%;\n  white-space:pre;\n  overflow-wrap:normal;\n  overflow-x:scroll;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
